import { apiUrl } from "../constants";
import axios from "axios";
import { stringify } from "querystring";
const path = `/SopTools/`;

var request = axios.create({
  baseURL: apiUrl,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  },
});

export default class SoporteToolsAPI {
  /**
   * Obtiene listado de puntos de venta paginado
   * @param {*} page
   * @param {*} filters
   * @param {*} pageSize
   * @returns
   */
  static getAllPdv(page, filters, pageSize = 10) {
    page = page || 1;
    pageSize = 10;
    filters = filters ? stringify(filters) : "";
    return request.get(
      `${path}PuntosVenta/?page=${page}&pageSize=${pageSize}&${filters}`,
    );
  }

  /**
   * Consulta detalle de punto de venta
   * @param {*} id
   * @returns
   */
  static getPdvById(id) {
    return request.get(`${path}PuntosVenta/${id}/`);
  }

  /**
   * Servicio para cambiar estatus de PDV
   * @param {*} id
   * @returns
   */
  static patchStatus(id) {
    return request.patch(`${path}PuntosVenta/${id}/`);
  }

  /**
   * Edita información completa de PDV
   * @param {*} id
   * @returns
   */
  static put(id, data) {
    return request.put(`${path}PuntosVenta/${id}/`, data);
  }

  static getPdvHorarios(id) {
    return request.get(`${path}PuntosVenta/${id}/Horarios/`);
  }

  static putPdvHorarios(id, data) {
    return request.put(`${path}PuntosVenta/${id}/Horarios/`, data);
  }

  /**
   * Sincroniza PDV con caffenio auth
   * @param {*} id
   * @returns
   */
  static syncAuth(id) {
    let data = {
      forceId: id,
      modeloNombre: "auth",
    };
    return request.post(`sync/api/auth/`, data);
  }
}
